const {
  NODE_ENV = 'development',
  REACT_APP_BANK_KEY = '__BankType',
  REACT_APP_BRAND_KEY = '__BrandType',
  REACT_APP_COUNTRY_KEY = '__CountryType',
  REACT_APP_FORCE_WITH_REFRESH,
  REACT_APP_TRACKING,
} = process.env;

export const config = {
  bankKey: REACT_APP_BANK_KEY,
  brandKey: REACT_APP_BRAND_KEY,
  countryKey: REACT_APP_COUNTRY_KEY,
  forceRefresh: REACT_APP_FORCE_WITH_REFRESH === 'true',
  isDevelopment: NODE_ENV === 'development',
  isProduction: NODE_ENV !== 'development',
  tracking: REACT_APP_TRACKING === 'true',
};
